import { useOutlet, useLocation } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { AnimatePresence } from "framer-motion";
import React from "react";

const Layout = () => {
  const location = useLocation();
  const element = useOutlet();

  return (
    <div className="layout-container">
      <div className="layout-container__header">
        <Header />
      </div>
      <div className="layout-container__body">
        <AnimatePresence mode="wait">
          {element ? React.cloneElement(element as React.ReactElement, { key: location.pathname }) : null}
        </AnimatePresence>
      </div>
      <div className="layout-container__footer">
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
